import { render } from "./AssignValuesBasedOnProductInformation.vue?vue&type=template&id=6afea823&scoped=true"
import script from "./AssignValuesBasedOnProductInformation.vue?vue&type=script&lang=js"
export * from "./AssignValuesBasedOnProductInformation.vue?vue&type=script&lang=js"

import "./AssignValuesBasedOnProductInformation.vue?vue&type=style&index=0&id=6afea823&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afea823"]])

export default __exports__